const ALLOWED_CNPJ = '18643656000198';
const SUPERADMIN_CPF = '03370993406';
const EXTRA_ALLOWED_CPFS = ['04057832483'];

export function isAdminBase(user, usuarioBind) {
  return !!(usuarioBind && user && usuarioBind.tipo === 'ADMIN' && user.role === 'ADMIN');
}

export function isAdminAuthorized(user, usuarioBind) {
  return isAdminBase(user, usuarioBind) && usuarioBind.cnpj === ALLOWED_CNPJ;
}

// Backwards-compatible: if only user is provided, checks cpf only
export function isSuperAdmin(user, usuarioBind) {
  if (usuarioBind !== undefined) {
    return isAdminAuthorized(user, usuarioBind) && user?.cpf === SUPERADMIN_CPF;
  }
  return !!(user && user.cpf === SUPERADMIN_CPF);
}

// Permissões adicionais: inclui CPFs específicos além do superadmin
export function isPrivilegedAdmin(user, usuarioBind) {
  if (!usuarioBind) return false;
  return EXTRA_ALLOWED_CPFS.includes(usuarioBind.cpf) || isSuperAdmin(user, usuarioBind);
}
